require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./clients-peppa-pig-world.json") })
        }
      }, "path---clients-peppa-pig-world");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---clients-peppa-pig-world!./.cache/json/clients-peppa-pig-world.json
// module id = 1383
// module chunks = 231608221292675